import React, { useState, useContext } from "react";
import { Avatar, Box, Collapse, Drawer, Hidden, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import { bakeStreetLogo, STORAGE_BUCKET } from "./constants";
import { getDeviceToken } from "../../firebase";
import bkstApi from "./api";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { isSuperAdmin } from "./util";
import ConfigContext from "./context/ConfigContext";

const drawerWidth = 240;

const muiListStyle = {
  color: "inherit",
  "&:hover": {
    color: "#202138",
    backgroundColor: "#EEE"
  },
  "& .MuiListItemIcon-root": {
    color: "inherit",
    minWidth: "36px"
  }
};
const muiListNestedStyle = {
  paddingLeft: "4rem",
  color: "inherit",
  "&:hover": {
    backgroundColor: "#EEE"
  }
};

export default function ResponsiveDrawer(props) {
  const container = window !== undefined ? () => document.body : undefined;
  const ctx = useContext(ConfigContext);

  const [showAdminSearchMenu, setShowAdminSearchMenu] = useState(false);

  const handleAdminSearchMenuClick = (e) => {
    e.stopPropagation();
    setShowAdminSearchMenu(!showAdminSearchMenu);
  };

  const enablePushNotifications = async (e) => {
    e.preventDefault();
    const token = await getDeviceToken();
    if (token) {
      bkstApi.post(`/fcm`, { token });
    }
  };
  console.log(">>>", ctx);

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", position: "relative" }}>
      <Box>
        <List>
          <ListItem component={RouterLink} to="/my/quote" sx={{ justifyContent: "center" }}>
            <img
              alt="logo"
              style={{ width: "110px", padding: "2px 3px 8px 3px", borderRadius: "5px", backgroundColor: "#EEE" }}
              src={bakeStreetLogo}
            ></img>
          </ListItem>
        </List>
      </Box>
      <List sx={{ flex: 1, overflowY: "auto", pb: 25 }}>
        <ListItem component={RouterLink} to="/order" sx={muiListStyle}>
          <ListItemIcon>
            <LocalMallOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={`Orders`} />
        </ListItem>
        <ListItem component={RouterLink} to="/request" sx={muiListStyle}>
          <ListItemIcon>
            <LocalAtmOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={`Quotes`} />
        </ListItem>
        {isSuperAdmin(ctx.uid) && (
          <ListItem component={RouterLink} to="/cash-advance" sx={muiListStyle}>
            <ListItemIcon>
              <AccountBalanceOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={`Cash Advance`} />
          </ListItem>
        )}
        {isSuperAdmin(ctx.uid) && (
          <ListItem component={RouterLink} to="/terminal" sx={muiListStyle}>
            <ListItemIcon>
              <ComputerOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={`Terminal`} />
          </ListItem>
        )}
        {isSuperAdmin(ctx.uid) && (
          <ListItem component={RouterLink} to="/login/reps" sx={muiListStyle}>
            <ListItemIcon>
              <PeopleAltOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={`Logins`} />
          </ListItem>
        )}
        <ListItem button onClick={handleAdminSearchMenuClick} sx={muiListStyle}>
          <ListItemIcon>
            <SearchOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Search" />
          {showAdminSearchMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={showAdminSearchMenu} timeout="auto" unmountOnExit>
          <ListItem component={RouterLink} to="/baker/search" sx={muiListStyle}>
            <ListItemIcon>
              <StorefrontIcon />
            </ListItemIcon>
            <ListItemText primary={`Bakeries`} />
          </ListItem>
          <List component="div" disablePadding>
            <ListItem component={RouterLink} to="/request/search" sx={muiListNestedStyle}>
              <ListItemText primary={`Requests`} />
            </ListItem>
          </List>
        </Collapse>
      </List>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          px: 2,
          pb: 2,
          pt: 2,
          textAlign: "center",
          backgroundColor: "inherit",
          borderTop: "1px solid #ECECEC"
        }}
      >
        <Box mb={1}>
          <Typography variant="overline" onClick={enablePushNotifications}>
            v{process.env.REACT_APP_VERSION}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "20px", justifyContent: "center", alignItems: "center" }}>
          <Avatar
            src={`${STORAGE_BUCKET}/img/b/-MVIf1diaYOCm5KynVDF/logo400.webp`}
            component={RouterLink}
            to={`/baker/-MVIf1diaYOCm5KynVDF`}
          />
          <Avatar
            src={`${STORAGE_BUCKET}/img/b/-MX2oaNrh4TcKVvnhcT9/logo400.webp`}
            component={RouterLink}
            to={`/baker/-MX2oaNrh4TcKVvnhcT9`}
          />
        </Box>
        {isSuperAdmin(ctx.uid) && <img style={{ width: "100%", borderRadius: "50%" }} src={`${STORAGE_BUCKET}/img/h/mascot.gif`} alt="Mascot" />}
      </Box>
    </Box>
  );

  console.log(">>>", props.open);

  return (
    <Box component="nav">
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant="temporary"
        anchor={"left"}
        open={props.open}
        onClose={props.toggle}
        onClick={props.toggle}
        ModalProps={{
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth, height: "100%" }
        }}
      >
        {drawer}
      </Drawer>
      {/* <Hidden xsDown implementation="css">
        <Drawer
          variant="permanent"
          open
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth, backgroundColor: "#202138", color: "#FFFFFF" }
          }}
        >
          {drawer}
        </Drawer>
      </Hidden> */}
    </Box>
  );
}
